module.exports = __webpack_public_path__ + "static/media/car-is-wrong.0afbf1ae.mp3";